import { useEffect } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import CopyID from "@/common/buttons/CopyID";
import { Actions as DOCUMENTACTIONS } from "@/store/actions/documentActions";
import { ArrowDownIcon, ArrowDownTrayIcon, ClipboardIcon, EnvelopeIcon } from "@heroicons/react/20/solid";
import Spinner from "@/common/Spinner";
import Tooltip from "@/common/tooltip/Tooltip";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

const DocumentRow = ({ row, downloadDocument, sendDocument, downloading, sending }) => {
	const { name, createdAt, id, emailStatus } = row;

	return (
		<tr>
			<td>
				<div
					className="btn btn-xs btn-default"
					type="button"
					onClick={() => copyToClipboard(id)}
					style={{ marginRight: 10 }}
				>
					<Tooltip content="Copy ID">
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</Tooltip>
				</div>
			</td>
			<td>{name}</td>
			<td>{format(new Date(createdAt), "do MMM yyyy HH:mm")}</td>
			<td>{emailStatus ?? "Not Sent"}</td>
			<td>
				<div className="btn-group">
					<button
						onClick={sendDocument}
						disabled={true || sending}
						className="btn btn-primary btn-xs"
					>
						{sending ? (
							<Spinner
								style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
								className="animate-spin h-5 w-5"
							/>
						) : (
							<EnvelopeIcon className="h-5 w-5 align-middle" />
						)}
					</button>

					<button
						onClick={downloadDocument}
						disabled={downloading}
						className="btn btn-primary btn-xs"
					>
						{downloading ? (
							<Spinner
								style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
								className="animate-spin h-5 w-5 "
							/>
						) : (
							<ArrowDownTrayIcon className="h-5 w-5 align-sub" />
						)}
					</button>
				</div>
			</td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {
	const id = ownProps.row.id;

	return {
		downloading: state.documents?.downloading?.[id] ?? false,
		sending: state.documents?.sending?.[id] ?? false,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	downloadDocument: () => dispatch(DOCUMENTACTIONS.downloadDocument(ownProps.row.id)),
	sendDocument: () => dispatch(DOCUMENTACTIONS.sendDocument(ownProps.row.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentRow);
